import gql from 'graphql-tag'

export const gridProduct = gql`
	fragment gridProduct on GridProduct {
		id
		mod_ver
		categoryId
		productId
		position
		product {
			id
			name
			code
			price
			img {
				uid
				key
			}
			category {
	    	id
	    	color
	    }
		}
	}
`
